import {RoleName, RoleNames, User} from '../models/user';
import {
  ServerUnreachableStatus,
  UnknownUserStatus,
  UserLoggedInStatus,
  UserLoggedOutStatus,
  UserStatusRoles
} from '../models/user-status';

function noRoles(): UserStatusRoles {
  return {
    Accountant: false,
    Administrator: false,
    ContentManager: false,
    ContentModerator: false,
    Student: false,
    Teacher: false,
    SystemAdministrator: false
  };
}

function unknown(): UnknownUserStatus {
  return {
    isLoggedIn: false,
    isLoggedOut: false,
    isUnknown: true,
    isServerUnreachable: false,
    user: null,
    roleNames: new Set(),
    roles: noRoles()
  };
}

function loggedOut(): UserLoggedOutStatus {
  return {
    isLoggedIn: false,
    isLoggedOut: true,
    isUnknown: false,
    isServerUnreachable: false,
    user: null,
    roles: noRoles(),
    roleNames: new Set()
  };
}

function serverUnreachable(): ServerUnreachableStatus {
  return {
    isLoggedIn: false,
    isLoggedOut: false,
    isUnknown: false,
    isServerUnreachable: true,
    user: null,
    roles: noRoles(),
    roleNames: new Set()
  };
}

function loggedIn(user: User): UserLoggedInStatus {
  const roles = new Set<RoleName>();
  for (let role of user.Roles)
    if (RoleNames.indexOf(role) !== -1)
      roles.add(role);
  return {
    isLoggedIn: true,
    isLoggedOut: false,
    isUnknown: false,
    isServerUnreachable: false,
    user: user,
    roles: {
      Accountant: roles.has('Accountant'),
      Administrator: roles.has('Administrator'),
      ContentManager: roles.has('ContentManager'),
      ContentModerator: roles.has('ContentModerator'),
      Student: roles.has('Student'),
      Teacher: roles.has('Teacher'),
      SystemAdministrator: roles.has('SystemAdministrator')
    },
    roleNames: roles
  };
}

class UserStatusBuilder {
  readonly unknown = unknown;
  readonly serverUnreachable = serverUnreachable;
  readonly loggedIn = loggedIn;
  readonly loggedOut = loggedOut;
}

export const userStatusBuilder = new UserStatusBuilder();
